import update from 'immutability-helper';
import { ActionType, defaultAction } from 'src/redux/types';
import {
  PaycheckoutConfiguration,
  PaycheckoutSettings,
  PaymentMethods,
} from '../types';
import { ACTION_TYPES } from './types';

export type PaymentMethodsState = {
  isLoading: boolean;
  error?: string;
  data?: PaymentMethods;
};

export type PaymentCheckoutState = {
  paymentMethods: PaymentMethodsState;
  settings: {
    data: PaycheckoutSettings;
    isLoading: boolean;
    success: boolean;
  };
  configuration: {
    data: PaycheckoutConfiguration | null;
    isLoading: boolean;
  };
  showCreatePaymentCheckoutModal: boolean;
  showCreateReusableModal: boolean;
};

const initialState: PaymentCheckoutState = {
  paymentMethods: {
    data: undefined,
    error: undefined,
    isLoading: false,
  },
  settings: {
    data: {
      last_updated: null,
      last_update_by: null,
      logo_url: null,
      primary_color: null,
      secondary_color: null,
    },
    isLoading: false,
    success: false,
  },
  configuration: {
    data: null,
    isLoading: false,
  },
  showCreatePaymentCheckoutModal: false,
  showCreateReusableModal: false,
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;

  switch (type) {
    case ACTION_TYPES.LOAD_AVAILABLE_PAYMENT_METHODS:
      return update(state, {
        paymentMethods: {
          isLoading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.LOAD_AVAILABLE_PAYMENT_METHODS_SUCCESS:
      return update(state, {
        paymentMethods: {
          data: {
            $set: {
              availableEWallets: payload.data.available_ewallets,
              availableBanks: payload.data.available_banks,
              availableOfflineChannels: payload.data.available_offline_channel,
              isCardAvailable: payload.data.is_card_available,
              isQrisRegistered: payload.data.is_qris_registered,
              isQrisDisabled: payload.data.is_qris_disabled,
              isAmountLessThan10kAllowed:
                payload.data.is_amount_less_than_10k_allowed,
              qrisMinimumAmount: payload.data.qris_minimum_amount,
            },
          },
          isLoading: {
            $set: false,
          },
        },
      });
    case ACTION_TYPES.LOAD_AVAILABLE_PAYMENT_METHODS_FAILED:
      return update(state, {
        paymentMethods: {
          error: {
            $set: payload.message,
          },
          isLoading: {
            $set: false,
          },
        },
      });
    case ACTION_TYPES.PAYCHECKOUT_LOAD_SETTINGS:
    case ACTION_TYPES.PAYCHECKOUT_UPDATE_SETTINGS:
      return update(state, {
        settings: {
          isLoading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.PAYCHECKOUT_LOAD_SETTINGS_SUCCESS:
      return update(state, {
        settings: {
          $set: {
            data: payload.data,
            isLoading: false,
            success: true,
          },
        },
      });
    case ACTION_TYPES.PAYCHECKOUT_LOAD_SETTINGS_FAILED:
    case ACTION_TYPES.PAYCHECKOUT_UPDATE_SETTINGS_SUCCESS:
      return update(state, {
        settings: {
          isLoading: {
            $set: false,
          },
          success: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.PAYCHECKOUT_UPDATE_SETTINGS_FAILED:
      return update(state, {
        settings: {
          isLoading: {
            $set: false,
          },
          success: {
            $set: false,
          },
        },
      });
    case ACTION_TYPES.PAYCHECKOUT_LOAD_CONFIGURATION:
    case ACTION_TYPES.PAYCHECKOUT_UPDATE_CONFIGURATION:
      return update(state, {
        configuration: {
          isLoading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.PAYCHECKOUT_LOAD_CONFIGURATION_SUCCESS:
      return update(state, {
        configuration: {
          $set: {
            data: payload.data,
            isLoading: false,
          },
        },
      });
    case ACTION_TYPES.PAYCHECKOUT_LOAD_CONFIGURATION_FAILED:
    case ACTION_TYPES.PAYCHECKOUT_UPDATE_CONFIGURATION_SUCCESS:
    case ACTION_TYPES.PAYCHECKOUT_UPDATE_CONFIGURATION_FAILED:
      return update(state, {
        configuration: {
          isLoading: {
            $set: false,
          },
        },
      });
    case ACTION_TYPES.SET_SHOW_CREATE_PAYMENT_CHECKOUT_MODAL:
      return update(state, {
        showCreatePaymentCheckoutModal: {
          $set: payload,
        },
      });
    case ACTION_TYPES.SET_SHOW_CREATE_REUSABLE_MODAL:
      return update(state, {
        showCreateReusableModal: {
          $set: payload,
        },
      });
    default:
      return state;
  }
};
